import React from "react";
import ClinicalPractitionerIA from "../../PatientsIP/ClinicalPractitioner/ClinicalPractitionerIA";
import ClinicalPractitionerReview from "../../PatientsIP/ClinicalPractitioner/ClinicalPractitionerReview";
import ClinicalPractitionerFormById from "../../PatientsIP/ClinicalPractitioner/ClinicalPractitionerFormById";
import { ADMISSION_TYPES } from "../../PatientsIP/ClinicalPractitioner/admissionContext";

const CLINICAL_FORM_PREFIX = "clinical-form-";

const ClinicalPractitionerOP = ({ admissionId, activeTab }) => {
  if (!admissionId || !activeTab) return null;

  if (activeTab === "ia") {
    return (
      <ClinicalPractitionerIA
        admissionId={admissionId}
        admissionType={ADMISSION_TYPES.OP}
      />
    );
  }
  if (activeTab === "review") {
    return (
      <ClinicalPractitionerReview
        admissionId={admissionId}
        admissionType={ADMISSION_TYPES.OP}
      />
    );
  }
  if (activeTab.startsWith(CLINICAL_FORM_PREFIX)) {
    return (
      <ClinicalPractitionerFormById
        formId={activeTab.slice(CLINICAL_FORM_PREFIX.length)}
        admissionId={admissionId}
        admissionType={ADMISSION_TYPES.OP}
      />
    );
  }
  return null;
};

export default ClinicalPractitionerOP;
